<template>
  <section class="max-w-xl mx-auto">
    <div class="flash flash--inline flash--warning">
      <strong v-text="'Warning:'" />
      <span v-text="warningText" />
    </div>
    <SelectPermissions @permissionSelected="(payload) => $emit('permissionSelected', payload)" />
    <div class="my-6 flex justify-center">
      <button
        type="button"
        class="btn-sm btn--link btn mr-6"
        @click="previousTab"
        v-text="'Back'"
      />
      <button
        type="button"
        class="btn-sm btn-primary btn"
        @click="nextTab"
        v-text="'Next'"
      />
    </div>
  </section>
</template>

<script type="text/babel">
import TabNavigation from 'Membership/Resources/assets/js/mixins/tab-navigation'
import HasSelectedMemberships from 'Membership/Resources/assets/js/components/bulk-edit/mixins/HasSelectedMemberships'
import SelectPermissions from './SelectPermissions'

export default {
  name: 'EditPermissions',
  components: {
    SelectPermissions,
  },
  mixins: [
    TabNavigation,
    HasSelectedMemberships,
  ],
  computed: {
    warningText() {
      return this.selectedMemberships.length === 1
        ? 'All permissions will be overwritten and replaced with those selected below for 1 member.'
        : `All permissions will be overwritten and replaced with those selected below for ${this.selectedMemberships.length} selected members.`
    },
  },
}
</script>
